{
	"backToManageDeclarations": "Zurück zu Erklärungen verwalten",
	"kpi": {
		"quantity": "Menge",
		"carbonSavings": "Kohlenstoffeinsparungen"
	},
	"downloadAllDeclarations": "Alle Erklärungen herunterladen",
	"errors": {
		"notFound": "Projekt nicht gefunden"
	}
}
